export default {
      id: "icon--ski-usage",
      viewBox: "0 0 25.7 25.7",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--ski-usage",
      toString: function () {
        return this.url;
      }
    }